
// make one to share between all models

import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js"


// MeshLambertMaterial	134
// MeshBasicMaterial	7
// SpriteMaterial	94
// MeshStandardMaterial	162
export const appGltfLoader = new GLTFLoader()

// console.log('appGltfLoader', appGltfLoader)

// MeshLambertMaterial	134
// MeshBasicMaterial	7
// SpriteMaterial	94
// MeshStandardMaterial	162
// export const appGltfLoader = new CustomGLTFLoader()
